
/* injects from baggage-loader */

angular.module('api', [
  "api.widget",
  "api.template",
  "api.section",
  "api.page",
  "api.font",
  "api.email",
  "api.sectionemail",
  "api.webform",
  "api.sectionwebform",
  "api.lesson",
  "api.sectionLesson"
]);



// WEBPACK FOOTER //
// ./src/app/editor/api/main.js